import { render, staticRenderFns } from "./CreateUblArchiveModalWrapper.vue?vue&type=template&id=20c55b5d"
import script from "./CreateUblArchiveModalWrapper.vue?vue&type=script&lang=ts"
export * from "./CreateUblArchiveModalWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c55b5d')) {
      api.createRecord('20c55b5d', component.options)
    } else {
      api.reload('20c55b5d', component.options)
    }
    module.hot.accept("./CreateUblArchiveModalWrapper.vue?vue&type=template&id=20c55b5d", function () {
      api.rerender('20c55b5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/CreateUblArchiveModalWrapper.vue"
export default component.exports